import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'

interface ArchiveBookingDialogProps {
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ArchiveBookingDialog: FC<ArchiveBookingDialogProps> = ({ isLoading = false, onConfirm, onCancel }) => (
  <Modal
    show
    onHide={onCancel}
    header={<h5 className='mb-0'>Archiving this booking</h5>}
    headerBodySeparator
    body={
      <div className='d-flex flex-column gap-3'>
        <span className='paragraph-small'>This booking moves to history, where you can recreate it with a new link.</span>
        <div className='d-flex align-items-start zocks-gap-0.5 p-3 rounded-2 paragraph-small border zocks-bg-color-warning-background zocks-border-color-warning'>
          <i className='bi bi-exclamation-triangle zocks-text-warning mt-1' />
          <span>This booking link stops working and can&apos;t be restored. Anyone who received it won&apos;t be able to book through it.</span>
        </div>
      </div>
    }
    showFooterActions
    footerPrimaryActionTitle='Archive booking'
    footerPrimaryActionLoading={isLoading}
    footerSecondaryActionTitle='Cancel'
    onFooterPrimaryAction={onConfirm}
    onFooterSecondaryAction={onCancel}
  />
)
